import React from 'react';
import { MapPin, MessageCircle, Globe, Phone, Building2 } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-funeral-dark">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-center gap-3 mb-4">
          <Phone className="text-funeral-gold" size={40} />
          <h2 className="text-4xl md:text-5xl font-serif text-center text-funeral-gold">
            Hubungi Kami
          </h2>
        </div>
        <div className="divider"></div>

        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12">
          <div className="bg-funeral-secondary/50 p-8 rounded-lg border border-funeral-border">
            <div className="flex items-center gap-3 mb-6">
              <Building2 className="text-funeral-gold" size={32} />
              <h3 className="text-2xl font-serif text-funeral-light">PT AI Indonesia</h3>
            </div>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4 p-4 bg-funeral-dark rounded-sm border border-funeral-border">
                <div className="bg-funeral-gold/10 p-2 rounded-full flex-shrink-0">
                  <MapPin className="text-funeral-gold" size={24} />
                </div>
                <div className="text-funeral-light">
                  <p>Office 88, Lantai 32</p>
                  <p>Kota Kasablanka</p>
                  <p>Jakarta 12870</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-funeral-dark rounded-sm border border-funeral-border hover:border-funeral-gold/50 transition-all">
                <div className="bg-funeral-gold/10 p-2 rounded-full flex-shrink-0">
                  <MessageCircle className="text-funeral-gold" size={24} />
                </div>
                <div className="text-funeral-light">
                  <p className="font-medium text-funeral-light mb-1">WhatsApp:</p>
                  <a 
                    href="https://wa.me/6287883468831" 
                    className="text-funeral-gold hover:text-funeral-gold/80 transition-colors flex items-center gap-2"
                  >
                    087883468831
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-funeral-dark rounded-sm border border-funeral-border hover:border-funeral-gold/50 transition-all">
                <div className="bg-funeral-gold/10 p-2 rounded-full flex-shrink-0">
                  <Globe className="text-funeral-gold" size={24} />
                </div>
                <div className="text-funeral-light">
                  <p className="font-medium text-funeral-light mb-1">Website:</p>
                  <a 
                    href="https://www.ai2.co.id" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-funeral-gold hover:text-funeral-gold/80 transition-colors"
                  >
                    www.ai2.co.id
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col justify-center items-center bg-funeral-secondary/50 p-8 rounded-lg border border-funeral-border hover:border-funeral-gold/50 transition-all">
            <p className="text-funeral-light text-center mb-6">
              Untuk informasi lebih lanjut mengenai layanan Kenangan.AI
            </p>
            <a 
              href="https://wa.me/6287883468831"
              className="inline-flex items-center gap-3 bg-[#25D366] text-white px-6 py-3 rounded-sm hover:bg-[#20BA5A] transition-all hover:scale-105 shadow-lg"
            >
              <MessageCircle size={24} />
              <span>Hubungi via WhatsApp</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
